import { IConfigFunctionArgs } from 'Components/Worksheets/Core';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from 'Components/Worksheets/QestIds';
import {
  IQuantity,
  isGreaterThanOrEqualTo as isIQuantityGreaterThanOrEqualTo,
  isLessThan as isIQuantityLessThan,
  toIQuantity,
} from 'Data/ViewModels/Core/IQuantity';
import * as oPath from 'Lib/Object/Path/Immutable';
import getDerivedFromMeasurementsConfig from './derivedFromMeasurementsConfig';
import getLabelConfig from './labelConfig';
import getMeasuredUsingConfig from './measuredUsingConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.DryingTemperature`]: {
        uom: '°C',
        format: { nearest: 1 },
      },
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.DryMassReadings.DryingTime`]: {
        uom: 'h',
        format: { nearest: 0.01 },
      },
      [`${prefix}.Results.PercentPassingWashingSieve`]: { format: { nearest: 0.1 } },
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.Balance`]: (configArgs: IConfigFunctionArgs) => {
        const measureWashedPortionWetMass = oPath.get(
          configArgs.worksheet,
          `${prefix}.Masses.MeasuredWashedConstantDryMass.Preparation.MeasureWashedPortionWetMass`
        );

        const sampleMass = measureWashedPortionWetMass
          ? oPath.get(configArgs.worksheet, `${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.WetSoilMass`)
          : oPath.get(configArgs.worksheet, `${prefix}.Masses.WashedDryMass`);

        return getDefaultReadability(sampleMass);
      },

      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.DryMassBalance`]: (
        configArgs: IConfigFunctionArgs
      ) => {
        const measureWashedPortionWetMass = oPath.get(
          configArgs.worksheet,
          `${prefix}.Masses.MeasuredWashedConstantDryMass.Preparation.MeasureWashedPortionWetMass`
        );

        const sampleMass = measureWashedPortionWetMass
          ? oPath.get(configArgs.worksheet, `${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.WetSoilMass`)
          : oPath.get(configArgs.worksheet, `${prefix}.Masses.WashedDryMass`);

        return getDefaultReadability(sampleMass);
      },
    },
    getLabelConfig(prefix)
  );

const getDefaultReadability = (sampleMass: IQuantity) => {
  //default readability: 0.1 when sampleMass >= 100 and sampleMass < 500
  let defaultReadability = 0.1;

  if (isIQuantityLessThan(sampleMass, toIQuantity(100, 'g'))) {
    defaultReadability = 0.01;
  } else if (isIQuantityGreaterThanOrEqualTo(sampleMass, toIQuantity(500, 'g'))) {
    defaultReadability = 1;
  }

  return {
    defaultReadability,
    defaultUom: 'g',
  };
};

export { getConfig };

export default {
  [qestIds.wash.AS_1289_3_6_1.Rev2009]: getConfig,
};
